var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "url(#paint0_linear_26_11598)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8438 25.9492C15.8438 20.2885 20.2787 16.0977 26 16.0977C31.7213 16.0977 36.1562 20.2885 36.1562 25.9492C36.1562 31.6099 31.7213 35.8008 26 35.8008C24.9724 35.8008 23.9864 35.6651 23.0601 35.4104C22.88 35.3608 22.6885 35.3748 22.5176 35.4502L20.5018 36.3401C19.9744 36.5729 19.3792 36.1979 19.3615 35.6216L19.3062 33.815C19.2994 33.5924 19.1993 33.3844 19.0334 33.2359C17.0572 31.4687 15.8438 28.9101 15.8438 25.9492ZM22.8843 24.0967L19.9009 28.8299C19.6146 29.2841 20.173 29.796 20.6007 29.4714L23.8053 27.0393C24.0221 26.8748 24.3217 26.8739 24.5394 27.0372L26.9123 28.8168C27.6243 29.3509 28.6405 29.1634 29.1151 28.4104L32.0985 23.6772C32.3848 23.2229 31.8264 22.7111 31.3987 23.0356L28.1941 25.4678C27.9773 25.6323 27.6777 25.6332 27.46 25.4699L25.0872 23.6902C24.3751 23.1562 23.3589 23.3437 22.8843 24.0967Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_11598",
    x1: 26,
    y1: 0,
    x2: 26,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF626F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F7BFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.314c2db16eef43d945fbb4d2ec4f824c.svg";
export { ForwardRef as ReactComponent };